import Vue from "vue";
import { networks } from "./constants/networks";

const config = Vue.observable({
  baseURL: parse(process.env.BASE_URL, "/"),
  nodeEnv: parse(process.env.NODE_ENV, "production"),
  appVersion: parse(process.env.VUE_APP_VERSION, "0.0.1"),
  network: networks[getNetworkId()] ?? networks['1'],
});

function getNetworkId() {
  let selectedNetwork = localStorage.getItem('selectedNetworkId')
  if (!selectedNetwork) {
    selectedNetwork = parse(process.env.VUE_APP_DEFAULT_NETWORK_ID, '1')
  }

  return selectedNetwork
}

function setNetwork(id) {
  localStorage.setItem('selectedNetworkId', id)
  config.network = networks[id]
}

export {
  config,
  setNetwork
}

function parse(value, fallback) {
  if (typeof value === "undefined") {
    return fallback;
  }

  switch (typeof fallback) {
    case "boolean":
      return !!JSON.parse(value);

    case "number":
      return JSON.parse(value);

    default:
      return value;
  }
}

export default {
  install(Vue) {
    Vue.appConfig = config;
    Vue.prototype.$appConfig = config;
  }
}
